/* eslint-disable */
import React, { useEffect } from 'react';
import cn from 'classnames';
import styles from './Payment.scss';
import { formatNumber } from 'utils'
import { useTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga'

const checkIcon = require('assets/images/icons/check-icon.svg');
const noIcon = require('assets/images/icons/icon-no.svg');

const checkIconPrint = require('assets/images/icons/check.svg');
const noIconPrint = require('assets/images/icons/icon-close.svg');

const digits = (number) => (number ? formatNumber(number) : 0);

const icon = (factor, print) => (
  <div className={styles.Image}>
    {print ?
        <img alt="icon" src={factor ? checkIconPrint : noIconPrint} />
        :
        <img alt="icon" src={factor ? checkIcon : noIcon} />
    }

  </div>
);

const Payment = ({ className, building, client, print, profile, objectType }) => {
  const { t } = useTranslation();
  const { payment, instalment_payments_conditions, gas_surcharge_price,
    surcharge_balcony, surcharge_communications, surcharge_docs, surcharge_trash,
    balcony_surcharge_price, communications_surcharge_price, docs_surcharge_price,
    trash_surcharge_price, country } = building.data;
  const { country_currency_symbol: currency } = country
  const { ipoteka, 
    military_ipoteka, 
    mat_capital, 
    installments, 
    cash, 
    taxes,
    is_ipoteka_family,
    is_ipoteka_state_support,
    is_ipoteka_it,
    is_ipoteka_tranche,
    is_ipoteka_subsidized,
    is_ipoteka_preferential } = payment;

  const arr = [
    {
      text: t('components.building.main.payment.taxes'),
      value: icon(taxes, print),
      check: taxes,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.military_ipoteka'),
      value: icon(military_ipoteka, print),
      check: military_ipoteka,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.ipoteka'),
      value: icon(ipoteka, print),
      check: ipoteka,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.is_ipoteka_it'),
      value: icon(is_ipoteka_it, print),
      check: is_ipoteka_it,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.is_ipoteka_family'),
      value: icon(is_ipoteka_family, print),
      check: is_ipoteka_family,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.is_ipoteka_state_support'),
      value: icon(is_ipoteka_state_support, print),
      check: is_ipoteka_state_support,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.is_ipoteka_subsidized'),
      value: icon(is_ipoteka_subsidized, print),
      check: is_ipoteka_subsidized,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.is_ipoteka_tranche'),
      value: icon(is_ipoteka_tranche, print),
      check: is_ipoteka_tranche,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.is_ipoteka_preferential'),
      value: icon(is_ipoteka_preferential, print),
      check: is_ipoteka_preferential,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.mat_capital'),
      value: icon(mat_capital, print),
      check: mat_capital,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.cash'),
      value: icon(cash, print),
      check: cash,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.installments'),
      subtext: instalment_payments_conditions,
      value: icon(installments, print),
      check: installments,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.surcharge_balcony'),
      value: t('components.building.main.payment.price', { price: formatNumber(balcony_surcharge_price), currency }),
      shouldDisplay: surcharge_balcony
    },
    {
      text: t('components.building.main.payment.surcharge_communications'),
      value: t('components.building.main.payment.price', { price: formatNumber(communications_surcharge_price), currency }),
      shouldDisplay: surcharge_communications
    },
    {
      text: t('components.building.main.payment.surcharge_docs'),
      value: t('components.building.main.payment.price', { price: formatNumber(docs_surcharge_price), currency }),
      shouldDisplay: surcharge_docs
    },
    {
      text: t('components.building.main.payment.surcharge_trash'),
      value: t('components.building.main.payment.price', { price: formatNumber(trash_surcharge_price), currency }),
      shouldDisplay: surcharge_trash
    }
  ];

  const gas = digits(gas_surcharge_price);
  if (gas !== 0) {
    arr.push({
      text: t('components.building.main.payment.gas'),
      value: <span>{t('components.building.main.payment.price', { price: gas, currency })}</span>,
      shouldDisplay: true
    });
  }

  const handleTrackEvent = () => {
    const { title, id } = building.data;

    trackGA(gaEvent.buildingInfoBlocksShow({
      eventLabel: 'oplata',
      productType: objectType,
      productName: title,
      productID: id,
      user_id: profile.id
    }));
  };

  useEffect(() => {
    handleTrackEvent();
  }, []);

  return (
    <div className={cn(styles.Payment, {[styles.Client]: client},  className, {[styles.PaymentPrint]: print})}>
      <h3 className={client ? styles.TitleClient : styles.Title}>
        {t('components.building.main.payment.pay')}
      </h3>
      <div className={client ? styles.InnerClient : styles.Inner}>
        {arr.map((row, index) => {
          if (row.check) {
            return (
              <div key={index} className={cn(styles.Row, ((row.text== 'Доплата за газ') ? styles.RowGas: null))}>
                <div className={cn(styles.Label, {[styles.LabelActive]: row.check})}>
                  <span>{row.text}</span>
                  {row.subtext ? <span className={styles.Subtext}>{row.subtext}</span> : null}
                </div>
                <div className={styles.Name}>
                  {row.value}
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default Payment;



// WEBPACK FOOTER //
// ./src/components/Building/Main/Payment/Payment.js